export default {
  title: {
    id: 'address_book_delete_rule_modal_title',
    defaultMessage: 'Deleting a rule',
  },
  body: {
    id: 'address_book_delete_rule_modal_body',
    defaultMessage: 'Do you really want to delete this rule?',
  },
  confirmation: {
    id: 'address_book_delete_rule_modal_confirmation',
    defaultMessage: 'Delete this rule',
  },
  cancel: {
    id: 'address_book_delete_rule_modal_cancel',
    defaultMessage: 'Cancel',
  },
}
